// Need to use the React-specific entry point to import createApi
import type {
  AuditLogResponse,
  GetAuditLogListRequestV2,
  GetListResponseOfAuditLogSimpleResponse,
  GetListResponseOfSelectOption,
} from 'src/api/ProactApiClient';
import {auditLogApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const auditLogApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getAuditLogListV2: builder.query<
      GetListResponseOfAuditLogSimpleResponse,
      GetAuditLogListRequestV2
    >({
      queryFn: clientQuery(params => auditLogApiClient.listV2(params)),
    }),
    getAuditLog: builder.query<AuditLogResponse, number>({
      queryFn: clientQuery(id => auditLogApiClient.get(id)),
    }),
    listEntityNameSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      void
    >({
      queryFn: clientQuery(() =>
        auditLogApiClient.listEntityNameSelectOptions()
      ),
    }),
    listEntityFieldSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      string
    >({
      queryFn: clientQuery(entityName =>
        auditLogApiClient.listEntityFieldSelectOptions(entityName)
      ),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAuditLogListV2Query,
  useGetAuditLogQuery,
  useListEntityNameSelectOptionsQuery,
  useListEntityFieldSelectOptionsQuery,
} = auditLogApi;
